import React from 'react';
import classnames from 'classnames';
import {
  KeyboardArrowRight as ArrowRight,
  KeyboardArrowLeft as ArrowLeft,
} from '@mui/icons-material';
import PopUpForm from '../../elements/pop-up-form/PopUpForm';

const styles = {
  collapseButton: {
    height: 36,
    width: 36,
  },
};

class AdvancedConfiguration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: true,
    };

    this._handleExpandButtonClicked = this._handleExpandButtonClicked.bind(this);
    this._handleFormFieldUpdated = this._handleFormFieldUpdated.bind(this);
  }

  render() {
    const {
      sinkConfigFields,
      sinkConfig,
      resourceMode,
      connectionType,
      connectionCategory,
      isModal,
    } = this.props;
    const { isExpanded } = this.state;
    let fields = sinkConfigFields;

    // Don't display panel if there are no advanced settings fields
    if (!fields || fields?.length === 0) {
      return null;
    }

    let fieldClassNames = [];
    fieldClassNames.push(`adv-settings-${resourceMode}`);
    if (connectionCategory) {
      fieldClassNames.push(`adv-settings-${connectionCategory}`);
    }

    if (connectionType) {
      fieldClassNames.push(`adv-settings-${connectionType}`);
    }

    return (
      <div
        className={classnames('advanced-configuration', {
          'is-collapsed': !isExpanded,
        })}
      >
        <div
          className={classnames({
            'collapse-button': isExpanded,
            'expand-button': !isExpanded,
            'in-modal': !!isModal,
          })}
          onClick={this._handleExpandButtonClicked}
        >
          {isExpanded ? (
            <ArrowRight fontSize="large" style={styles.collapseButton} />
          ) : (
            <ArrowLeft fontSize="large" style={styles.collapseButton} />
          )}
          <div>Advanced Settings</div>
        </div>
        <PopUpForm
          heading="Advanced Settings"
          data={sinkConfig}
          fields={fields}
          showRequiredIndicator={false}
          showCloseButton={false}
          onFieldUpdated={this._handleFormFieldUpdated}
          isCredentialsForm={false}
          fieldClassNames={fieldClassNames}
          isModal={!!isModal}
          rootStyle={{
            width: 300,
          }}
        />
      </div>
    );
  }

  _handleExpandButtonClicked() {
    const { isExpanded } = this.state;
    this.setState({ isExpanded: !isExpanded });
  }

  _handleFormFieldUpdated(name, value, data) {
    this.props.onSourceConfigChanged(data, name, value);
  }
}

export default AdvancedConfiguration;
